import { Component, Inject, OnInit, Type } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface DialogContentData {
  entryComponent: Type<any>
  title: string
  message: string
  data?:any
  positiveCallbackBtnLabel?:string
  cancleCallback?: () => void
  positiveCallback?: (data?) => void
}

@Component({
  selector: 'app-generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.css']
})
export class GenericDialogComponent implements OnInit {
  okBtnLabel = this.translate.instant('gen_dialog_btn_ok')
  constructor(
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContentData,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    if(this.data.positiveCallbackBtnLabel)
    this.okBtnLabel = this.data.positiveCallbackBtnLabel
  }

  onCancle() {
    if (this.data.cancleCallback) {
      this.data.cancleCallback()
    }
    this.dialogRef.close()
  }

  onConfirm() {
    if (this.data.positiveCallback) {
      this.data.positiveCallback()
    }
    this.dialogRef.close()
  }

}
